import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface AddedToCartModalProps {
  show: boolean;
  onHide: () => void;
  productName: string;
  orderPrice: number;
  onCheckoutNow: () => void;
}

const AddedToCartModal: React.FC<AddedToCartModalProps> = ({ show, onHide, productName, orderPrice, onCheckoutNow }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title className="fw-bold text-dark">
        <i className="fas fa-check-circle text-success me-2"></i> Added to Cart!
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="text-muted mb-0">
        <strong>{productName}</strong> was successfully added to your shopping cart.
      </p>
      <div className="bg-light p-3 border rounded-3 mt-3">
        <div className="small text-muted mb-1">Specifications Subtotal:</div>
        <div className="fw-bold text-dark h5 mb-0">₹{orderPrice.toLocaleString('en-IN')}</div>
      </div>
    </Modal.Body>
    <Modal.Footer className="d-flex justify-content-between border-top-0 pt-0">
      <Button variant="outline-secondary" onClick={onHide} style={{ borderRadius: '8px' }}>
        Continue Shopping
      </Button>
      <Button
        className="btn-quote text-white px-4"
        onClick={onCheckoutNow}
        style={{ borderRadius: '8px' }}
      >
        Checkout Now <i className="fas fa-shopping-bag ms-1"></i>
      </Button>
    </Modal.Footer>
  </Modal>
);

export default AddedToCartModal;
